/* eslint-disable react/no-array-index-key */
import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import { DashboardKeyValueRankingKpi } from 'src/services/kpi';
import { getProductImageUrl } from 'src/services/products';
import { Link } from 'react-router-dom';
import ProductListItem from '../../ui/ListItems/Product/Product';
import styles from './DashboardKeyValueRankingKpiCard.module.scss';
import CardContainer from '../../layouts/CardContainer/CardContainer';

interface PopularProductsCardProps {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  data: DashboardKeyValueRankingKpi;
}

const DashboardKeyValueRankingKpiCard: React.FC<PopularProductsCardProps> = ({
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  data,
}) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  return (
    <CardContainer
      className={classNames(styles.root)}
      ref={setNodeRef}
      style={style}
      label={data.title}
      attributes={attributes}
      listeners={listeners}>
      <div className={classNames('flex flex-col gap-y-16')}>
        {Array.isArray(data.value) &&
          data.value.map((item, idx) => {
            const content = (
              <ProductListItem
                imageSrc={item.product_id ? getProductImageUrl(item.product_id) : undefined}
                productName={item.product_name}
                productNumber={item.total_sold.toString()}
              />
            );
            return (
              <div key={idx}>
                {item.product_id !== undefined ? (
                  <Link to={`/warehouse/inventory/${item.product_id}`}>{content}</Link>
                ) : (
                  content
                )}
              </div>
            );
          })}
      </div>
    </CardContainer>
  );
};

export default DashboardKeyValueRankingKpiCard;
